<template>
  <div class="equipment-view p-6">
    <h1 class="text-2xl font-bold mb-4">Equipment</h1>
    <p class="mb-6 text-gray-600">Manage your farm equipment here. Add, edit, or view equipment details.</p>
    <EquipmentList />
  </div>
</template>

<script setup lang="ts">
import EquipmentList from '@/components/equipment/EquipmentList.vue';
</script>
